(function (root) {
  function buildQuery(text, category = '', subcategory = '') {
    const parts = ['tag:"business_unit_supermarket"'];
    for (const tag of [category, subcategory]) {
      if (!tag) continue;
      if (!/^gss-(category|subcategory)-[a-z0-9-]+$/.test(tag)) throw new Error('Invalid category');
      parts.push('tag:"' + tag + '"');
    }
    for (const word of text.trim().split(/\s+/).filter(Boolean)) {
      parts.push('"' + word.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"');
    }
    return parts.join(' AND ');
  }
  function latestOnly() {
    let version = 0;
    return async (pending, commit) => {
      const current = ++version;
      const value = await pending;
      if (current === version) commit(value);
    };
  }
  function canPurchase(product) {
    return product.available && product.price > 0 &&
      product.tags.includes('gss-sellable-reviewed') && !product.tags.includes('gss-price-pending');
  }
  function updateEnquiry(list, item, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 999) throw new Error('Use a whole quantity from 0 to 999');
    const next = list.filter(entry => entry.id !== item.id);
    if (quantity) next.push({ id: String(item.id), title: String(item.title), url: String(item.url), quantity });
    return next;
  }
  function enquiryText(list) {
    return 'Hello GemStop Bentley, please check availability for:\n\n' +
      list.map(item => item.quantity + ' × ' + item.title).join('\n') +
      '\n\nPlease confirm current prices and availability. This is an enquiry, not an order or reservation.';
  }
  const api = { buildQuery, latestOnly, canPurchase, updateEnquiry, enquiryText };
  if (typeof module !== 'undefined') module.exports = api;
  else root.GemStopSupermarketState = api;
})(typeof window === 'undefined' ? {} : window);
